const dialogQueue = {
  namespaced: true,

  state: {
    queue: [],
  },

  getters: {
    activeId: state => (state.queue.length > 0 ? state.queue[0].id : null),
    isActive: (state, getters) => id => getters.activeId === id,
    isQueued: state => id => state.queue.some(item => item.id === id),
  },

  mutations: {
    set(state, { type, value }) {
      state[type] = value
    },
  },

  actions: {
    request({ commit, state, getters }, { id, priority = 0 }) {
      if (getters.isQueued(id)) return
      const next = [...state.queue, { id, priority }]
        .sort((a, b) => b.priority - a.priority)
      commit('set', { type: 'queue', value: next })
    },

    release({ commit, state }, id) {
      commit('set', {
        type: 'queue',
        value: state.queue.filter(item => item.id !== id),
      })
    },
  },
}

export default dialogQueue
